import { useState } from 'react';
import { View } from 'foundations-components/components/View';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import { gate as gateV3 } from 'hub-http/gates';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import IsUngatedStore from 'crm_data/gates/IsUngatedStore';
import { MeetingNotetakerAlert } from 'MeetingsLib/components/breeze/MeetingNotetakerAlert';
import { MeetingNotetakerInfo } from 'MeetingsLib/components/breeze/MeetingNotetakerInfo';
import { MEETING_NOTETAKER_ALERT_DISMISSED } from 'MeetingsLib/constants/localStorage';
import { useLocalStorageState } from 'crm-meetings-components-lib/hooks/useLocalStorageState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ungatedForMeetingNotetakerDependency = {
  stores: [IsUngatedStore],
  deref: () => IsUngatedStore.get(gateV3('Meetings:MeetingNotetaker'))
};
export function MeetingNotetakerAlertAndModal() {
  const [isMeetingNotetakerModalOpen, setIsMeetingNotetakerModalOpen] = useState(false);
  const [isMeetingNotetakerModalDismissed] = useLocalStorageState({
    key: MEETING_NOTETAKER_ALERT_DISMISSED,
    initialValue: false
  });
  const isUngatedForMeetingNotetaker = useStoreDependency(ungatedForMeetingNotetakerDependency);
  if (!isUngatedForMeetingNotetaker) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    paddingInline: "400",
    marginBlockStart: "400",
    children: [!isMeetingNotetakerModalDismissed && /*#__PURE__*/_jsx(MeetingNotetakerAlert, {
      onLearnMoreClick: () => setIsMeetingNotetakerModalOpen(true)
    }), isMeetingNotetakerModalOpen && /*#__PURE__*/_jsx(MeetingNotetakerInfo, {
      manageSettings: true,
      onCancel: () => setIsMeetingNotetakerModalOpen(false)
    })]
  });
}